@if (this.node().attrs['messageSize']) {
  <div class="file-wrapper" contenteditable="false">
    <button class="file-button file-border" data-testid="link_downloadfile" mat-button tabindex="0">
      <div class="file-actions">
        @let fileIcon = getFileTypeIcon(this.node().attrs['messageBody']);
        @if (fileIcon) {
          <mat-icon svgIcon="{{ fileIcon }}"></mat-icon>
        }
        <span class="clamp-text file-name-button">{{ this.node().attrs['messageBody'] }}</span>
        <span>({{ formatFileSize(this.node().attrs['messageSize']) }})</span>
        <mat-icon svgIcon="information" class="file-action-icon"></mat-icon>
        <mat-icon svgIcon="copy-link" class="file-action-icon"></mat-icon>
        <mat-icon svgIcon="three-dots" class="file-action-icon"></mat-icon>
      </div>
    </button>
  </div>
}
<p class="test" tiptapNodeViewContent></p>
